<template>
  <div @click.stop="toggle">
    <slot v-bind="{ confirmed: isConfirmed, count, reset }"></slot>
  </div>
</template>
<script>
import { useEventListener } from "@vueuse/core";
import { computed, defineComponent, shallowRef } from "vue";

export default defineComponent({
  emits: ["call", "reset"],
  setup(_, { emit }) {
    const count = shallowRef(0);

    const isConfirmed = computed(() => count.value === 1);

    function reset() {
      count.value = 0;
      emit("reset");
    }

    function toggle() {
      if (isConfirmed.value) {
        emit("call");
        reset();
        return;
      }

      count.value = 1;
    }

    useEventListener(document, "click", reset);

    return {
      isConfirmed,
      count,
      reset,
      toggle,
    };
  },
});
</script>
